/**
 * Diretiva responsável por apresentar uma lista de telefones.
 */

angular.module("avlib").directive("avPhoneDisplay", function(){
	return {
		template: require("!html-loader!./PhoneDisplayTemplate.html"),
		restrict: "E",
		scope: {
			phones: '=',
			completeList: '=?',
		},
		link: function(scope, elem, attrs, ctrl){
			if (attrs["completeList"] === undefined){
				scope.completeList = true;
			}
		},
		controller: ["$scope", function($scope){
			$scope.$watch('phones', function(newValue, oldValue, $scope) {
				$scope.whatsapp = [];
				$scope.nonWhatsapp = [];
				if ($scope.phones != null){
					$scope.phones.forEach(function(phone){
						if (phone.whatsapp){
							$scope.whatsapp.push(phone);
						}else{
							$scope.nonWhatsapp.push(phone);
						}
					});
				}
		    }, true);
		}],
	};
});
